import { useState } from 'react';

interface HeaderProps {
  title: string;
  subtitle?: string;
}

export default function Header({ title, subtitle }: HeaderProps) {
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <header className="bg-white border-b border-slate-200 px-8 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>

        <div className="flex items-center gap-4">
          {/* 搜索框 */}
          <div className="relative">
            <input
              type="text"
              placeholder="搜索文档、规则..."
              className="w-80 pl-10 pr-4 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-base"></i>
          </div>

          {/* 通知 */}
          <div className="relative">
            <button
              onClick={() => setShowNotifications(!showNotifications)}
              className="w-10 h-10 flex items-center justify-center hover:bg-slate-100 rounded-lg transition-colors relative cursor-pointer"
            >
              <i className="ri-notification-3-line text-xl text-slate-600"></i>
              <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>

            {showNotifications && (
              <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-slate-200 z-50">
                <div className="p-4 border-b border-slate-200">
                  <h3 className="font-semibold text-slate-900">通知</h3>
                </div>
                <div className="max-h-96 overflow-y-auto">
                  <div className="p-4 hover:bg-slate-50 cursor-pointer border-b border-slate-100">
                    <div className="flex gap-3">
                      <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                      <div className="flex-1">
                        <p className="text-sm text-slate-900">新文档"员工行为规范"已完成解析</p>
                        <p className="text-xs text-slate-500 mt-1">5分钟前</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 hover:bg-slate-50 cursor-pointer border-b border-slate-100">
                    <div className="flex gap-3">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <div className="flex-1">
                        <p className="text-sm text-slate-900">47条规则等待审核</p>
                        <p className="text-xs text-slate-500 mt-1">1小时前</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 hover:bg-slate-50 cursor-pointer">
                    <div className="flex gap-3">
                      <div className="w-2 h-2 bg-amber-500 rounded-full mt-2 flex-shrink-0"></div>
                      <div className="flex-1">
                        <p className="text-sm text-slate-900">智能体"人事助手"调用量突破1000次</p>
                        <p className="text-xs text-slate-500 mt-1">3小时前</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-3 border-t border-slate-200 text-center">
                  <a href="#" className="text-sm text-teal-600 hover:text-teal-700 cursor-pointer">
                    查看全部通知
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* 帮助 */}
          <button className="w-10 h-10 flex items-center justify-center hover:bg-slate-100 rounded-lg transition-colors cursor-pointer">
            <i className="ri-question-line text-xl text-slate-600"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
